import { ManualExpenditureType } from "../model/types";

const typesNamesDict: Record<ManualExpenditureType, string> = {
  work: "Работа",
  worker: "Сотрудник",
  equipment: "Оборудование",
  machine: "МиМ",
  material: "Материал",
  transport: "Транспорт",
};


export const getResourceName = (type: ManualExpenditureType) => typesNamesDict[type]; 
export const getResourceSymbol = (type: ManualExpenditureType) => getResourceName(type).substring(0, 1); 